import React, {useState} from 'react';
import {
    CheckCircleOutlined,
    DownCircleTwoTone,
    LockOutlined,
    PlaySquareFilled,
} from "@ant-design/icons";
import {Button, Collapse} from "antd";
import {useHistory, useLocation} from "react-router-dom";
import {jumpIntoCourseQuiz} from "../pages/ModulePage";
import {useTranslation} from "react-i18next";
import {getCourseShortName} from "../../shared/helper";
import {program_enrol_user_to_course} from "../../shared/service";

function Modules(props) {
    const {t} = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const [loadingQuiz, setLoadingQuiz] = useState(0);
    let {courses = [], programid, templateid} = props;
    let retry = 3;
    const initialShowCount = 5;
    const [showCount, setShowCount] = useState(initialShowCount);
    const [showMore, setShowMore] = useState(false);
    const isProgramDetail = !!location?.pathname?.includes('/programs');

    function jumpIntoQuiz(course) {
        if (course.unlocked && !!retry) {
            let {courseid} = course;
            setLoadingQuiz(courseid);

            jumpIntoCourseQuiz(programid, courseid, course.name, history, (response) => {
                setLoadingQuiz(0);
                if (response) {
                    if (response === 'errorcoursecontextnotvalid' || response.hasOwnProperty('errorcoursecontextnotvalid')) {
                        if (course.unlocked && !course.isenrolled) {
                            retry--;
                            program_enrol_user_to_course(templateid, courseid).then(status => {
                                if (status) {
                                    jumpIntoQuiz(course);
                                    setLoadingQuiz(0);
                                }
                            });
                        }
                    }
                }
            });
        }
    }

    function jumpIntoCourse(course) {
        if (course.unlocked) {
            history.push(`/programs/${programid}/courses/${course.courseid}`);
        }
    }

    const ModuleSummary = ({course}) => {
        let {video_module} = course;

        let videoCompleted = false;
        if (Array.isArray(video_module)) {
            video_module.forEach(available_video_module => {
                if (available_video_module.video_completion) {
                    videoCompleted = true;
                }
            });
        }

        return (
            <div
                className={`module ${course.iscompleted ? 'completed' : 'incompleted'} ${course.isenrolled ? '' : 'notenrolled'} ${course.unlocked ? 'unlocked' : 'locked'}`}>
                <div className="module_left">
                    <div className="module_title">
                        {
                            course.unlocked ?
                                (
                                    course.iscompleted ? <CheckCircleOutlined/> :
                                        <PlaySquareFilled style={videoCompleted ? {color: '#52C41A'} : null}/>
                                ) : <LockOutlined/>
                        }
                        <span className={'course-name'} onClick={() => course.unlocked && jumpIntoCourse(course)}>
                            {t(getCourseShortName(course.name), course.name)}
                        </span>
                        {
                            course?.shortdescription && (
                                <span className={'arrow-icon'}>
                                    <DownCircleTwoTone/>
                                </span>
                            )
                        }
                    </div>
                    <div className={'module_details with_separator'}>
                        <span>
                            Video ({course?.courseduration || '-'})
                        </span>
                        <span className={'detail_separator'}/>
                        <span>
                            Quiz (7 questions)
                        </span>
                    </div>
                </div>
                <div className="module_right">
                    {
                        (course.unlocked && !course?.iscompleted) && (
                            <Button type={'primary'} onClick={() => {
                                jumpIntoCourse(course)
                            }}>{course?.isenrolled && (course?.lastaccess || course?.progress) ? 'Resume' : 'Start Now'}</Button>
                        )
                    }
                </div>
            </div>
        );
    };

    const handleShowMore = () => {
        if (showMore) {
            setShowCount(courses?.length);
        } else {
            setShowCount(initialShowCount);
        }
    }

    const ModuleContent = ({modules}) => {

        if (isProgramDetail) {
            setShowCount(modules?.length);
        }

        const filteredCourseList = modules?.filter((course, index) => index < showCount);
        const moduleCount = filteredCourseList.length;
        const showDiff = modules?.length - showCount;
        let showMoreText = 'Show less';
        setShowMore(false);
        if (showDiff > 0) {
            showMoreText = `Show ${showDiff} more`;
            setShowMore(true);
        }

        return (
            <Collapse>
                {
                    filteredCourseList.map((course) =>
                        (
                            <>
                                <Collapse.Panel
                                    key={course?.id}
                                    className={`module-panel ${!course?.shortdescription && 'no-short-description'}`}
                                    header={<ModuleSummary course={course}/>}
                                    showArrow={false}
                                    collapsible={!!course?.shortdescription ? '' : 'disabled'}
                                >
                                    {course?.shortdescription}
                                </Collapse.Panel>
                                {
                                    (moduleCount > 1) && <hr/>
                                }
                            </>
                        )
                    )
                }
                {
                    (!isProgramDetail && (modules.length > initialShowCount)) && (
                        <Collapse.Panel
                            key={'show-more'}
                            className={'show-more-panel'}
                            header={
                                <Button onClick={handleShowMore} type={'link'}>{showMoreText}</Button>}
                            showArrow={false}
                            collapsible={'header'}
                        />
                    )
                }
            </Collapse>
        );
    };

    return (
        <div className={"program_body"}>
            <div className={"program_content"}>
                <div className={"modules"}>
                    <ModuleContent modules={courses}/>
                </div>
            </div>
        </div>
    );
}

export default Modules;
